<template>
    <div class="accordion__item js-accordion-item">
        <div v-if="name" class="accordion-header js-accordion-header" @click="toggleAccordion">
            {{ name }}
        </div>
        <!-- Accordion Body -->
        <transition name="accordion">

            <div v-show="isOpen" class="accordion-body js-accordion-body">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: "Panel 1"
        },
    },
    data() {
        return {
            isOpen: false // Controls the visibility of the accordion body
        };
    },
    methods: {
        toggleAccordion() {
            this.isOpen = !this.isOpen; // Toggles the accordion body visibility
        }
    }
}
</script>

<style>
/* Add necessary CSS styles for the accordion */
.accordion-header {
    cursor: pointer;
    /* Changes the cursor to pointer when hovering over the header */
}

.accordion-body {
    display: block;

}

/* Vue Transition Classes */
.accordion-enter-active,
.accordion-leave-active {
    transition: all 0.5s ease;
}

.accordion-enter,
.accordion-leave-to

/* Starting and ending states */
    {
    opacity: 0;
    transform: scaleY(0);
}

.accordion-leave-active {
    position: absolute;
}</style>
